// Lista de eventos do organizador (`/events`), a home do painel. Os rótulos
// de status seguem os do app (`eventStatus*` nas ARBs), menos "Publicado",
// que no painel é o estado do cadastro e não "Próximo".
import { defineMessages } from '../core';

export const eventsT = defineMessages('events', {
  pt: {
    title: 'Eventos',
    intro: 'Gerencie eventos cadastrados ou comece um novo.',
    newEvent: 'Novo evento',
    loadFailed: (message: string) => `Falha carregando eventos: ${message}`,
    emptyTitle: 'Nenhum evento ainda',
    emptyBody: 'Clique em "Novo evento" pra começar o wizard de cadastro.',
    searchPlaceholder: 'Buscar por nome ou slug…',
    searchLabel: 'Buscar eventos',
    clearSearch: 'Limpar busca',
    filterAll: 'Todos',
    status: {
      draft: 'Rascunho',
      published: 'Publicado',
      running: 'Em andamento',
      finished: 'Encerrado',
    },
    filteredCount: (shown: number, total: number) => `${shown} de ${total}`,
    noMatch: 'Nenhum evento corresponde à busca.',
    clearFilters: 'Limpar filtros',
    noSlug: 'sem slug',
    trackersChip: 'Rastreadores',
    /// #1172 — atalho pro check-in de rastreadores (só com a flag do evento).
    trackersCheckin: 'Check-in de rastreadores',
    publish: 'Publicar',
    publishing: 'Publicando…',
    finish: 'Encerrar',
    finishing: 'Encerrando…',
    organizerDashboard: 'Painel organizador',
    results: 'Resultados',
    deleteEvent: 'Excluir evento',
    confirmFinishTitle: 'Encerrar a prova?',
    confirmFinishBody: 'Atletas que ainda não cruzaram não terão FinishTime gravado.',
    confirmDeleteTitle: 'Excluir este evento?',
    confirmDeleteBody:
      'Apaga em definitivo o evento e tudo ligado a ele: categorias, dias, segmentos, inscrições, veículos, zonas e convites. Não dá pra desfazer.',
    deleteFailed: 'Não foi possível excluir o evento',
    /// Códigos de erro do backend na exclusão. Código fora daqui aparece cru.
    errors: {
      event_has_active_trackers:
        'Ainda há atletas deste evento com rastreador. Devolva os aparelhos no check-in de rastreadores antes de excluir.',
    },
  },
  en: {
    title: 'Events',
    intro: 'Manage your events or start a new one.',
    newEvent: 'New event',
    loadFailed: (message) => `Failed to load events: ${message}`,
    emptyTitle: 'No events yet',
    emptyBody: 'Click "New event" to start the setup wizard.',
    searchPlaceholder: 'Search by name or slug…',
    searchLabel: 'Search events',
    clearSearch: 'Clear search',
    filterAll: 'All',
    status: {
      draft: 'Draft',
      published: 'Published',
      running: 'In progress',
      finished: 'Finished',
    },
    filteredCount: (shown, total) => `${shown} of ${total}`,
    noMatch: 'No events match your search.',
    clearFilters: 'Clear filters',
    noSlug: 'no slug',
    trackersChip: 'Trackers',
    trackersCheckin: 'Tracker check-in',
    publish: 'Publish',
    publishing: 'Publishing…',
    finish: 'End',
    finishing: 'Ending…',
    organizerDashboard: 'Organizer dashboard',
    results: 'Results',
    deleteEvent: 'Delete event',
    confirmFinishTitle: 'End the race?',
    confirmFinishBody: "Athletes who haven't crossed yet won't have a finish time recorded.",
    confirmDeleteTitle: 'Delete this event?',
    confirmDeleteBody:
      'Permanently deletes the event and everything linked to it: categories, days, segments, signups, vehicles, zones and invites. This cannot be undone.',
    deleteFailed: 'Could not delete the event',
    errors: {
      event_has_active_trackers:
        'Athletes in this event still have trackers. Return the devices in tracker check-in before deleting.',
    },
  },
  es: {
    title: 'Eventos',
    intro: 'Administra los eventos registrados o empieza uno nuevo.',
    newEvent: 'Nuevo evento',
    loadFailed: (message) => `No se pudieron cargar los eventos: ${message}`,
    emptyTitle: 'Todavía no hay eventos',
    emptyBody: 'Haz clic en "Nuevo evento" para empezar el asistente de registro.',
    searchPlaceholder: 'Buscar por nombre o slug…',
    searchLabel: 'Buscar eventos',
    clearSearch: 'Borrar búsqueda',
    filterAll: 'Todos',
    status: {
      draft: 'Borrador',
      published: 'Publicado',
      running: 'En curso',
      finished: 'Finalizado',
    },
    filteredCount: (shown, total) => `${shown} de ${total}`,
    noMatch: 'Ningún evento coincide con la búsqueda.',
    clearFilters: 'Borrar filtros',
    noSlug: 'sin slug',
    trackersChip: 'Rastreadores',
    trackersCheckin: 'Check-in de rastreadores',
    publish: 'Publicar',
    publishing: 'Publicando…',
    finish: 'Finalizar',
    finishing: 'Finalizando…',
    organizerDashboard: 'Panel del organizador',
    results: 'Resultados',
    deleteEvent: 'Eliminar evento',
    confirmFinishTitle: '¿Finalizar la prueba?',
    confirmFinishBody: 'Los atletas que todavía no cruzaron no tendrán tiempo de llegada registrado.',
    confirmDeleteTitle: '¿Eliminar este evento?',
    confirmDeleteBody:
      'Elimina definitivamente el evento y todo lo vinculado a él: categorías, días, segmentos, inscripciones, vehículos, zonas e invitaciones. No se puede deshacer.',
    deleteFailed: 'No se pudo eliminar el evento',
    errors: {
      event_has_active_trackers:
        'Todavía hay atletas de este evento con rastreador. Devuelve los equipos en el check-in de rastreadores antes de eliminar.',
    },
  },
});
